import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

Alpine.plugin(persist);
window.Alpine = Alpine;
Drupal.behaviors.alpinejs = {
  isStarted: false,
  attach() {
    if (Drupal.behaviors.alpinejs.isStarted === false) {
      Alpine.start();
      Drupal.behaviors.alpinejs.isStarted = true;
    }
  },
};
